import { Authentication, ConfigurationManager } from "@/utils";

class Api {
    constructor() {
        this.get = this.get.bind(this);
        this.post = this.post.bind(this);
        this.put = this.put.bind(this);
        this.patch = this.patch.bind(this);
        this.delete = this.delete.bind(this);
        this.get = this.get.bind(this);
        this.upload = this.upload.bind(this);
    }

    _getUri = (endpointUri) =>
        `${ConfigurationManager.values.api}${endpointUri}`;

    async _getHeaders() {
        const { orgKey } = ConfigurationManager.values;
        return {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Authentication.getToken()}`,
            "atr-entity-key": orgKey,
        };
    }

    async _parseResponseBody(response) {
        const contentType = response.headers.get("content-type");

        const responseType =
            contentType && contentType.indexOf("application/json") !== -1
                ? "json"
                : "text";

        return await response[responseType]();
    }

    async _handleResponse(response, { parseErrorBody = false } = {}) {
        const { status, statusText } = response;

        if (status >= 300) {
            let errorBody = null;

            if (parseErrorBody) {
                errorBody = await this._parseResponseBody(response);
            }

            const error = new Error(statusText);
            error.statusCode = status;
            error.errorMessage = statusText;
            error.errorBody = errorBody;

            throw error;
        }

        return this._parseResponseBody(response);
    }

    async get(url, config = {}, options = {}) {
        return this._request(
            url,
            {
                ...config,
                method: "GET",
            },
            options,
        );
    }

    async post(url, data, config = {}, options = {}) {
        return this._request(
            url,
            {
                ...config,
                headers: {
                    "Content-Type": "application/json",
                },
                method: "POST",
                body: JSON.stringify(data),
            },
            options,
        );
    }

    async upload(url, file, config = {}) {
        const form = new FormData();
        form.append("file", file);
        return this._request(
            url,
            {
                ...config,
                method: "PUT",
                body: form,
            },
            { shouldRemove: true },
        );
    }

    async put(url, data, config = {}, options = {}) {
        return this._request(
            url,
            {
                ...config,
                headers: {
                    "Content-Type": "application/json",
                },
                method: "PUT",
                body: JSON.stringify(data),
            },
            options,
        );
    }

    async patch(url, data, config = {}) {
        return this._request(url, {
            ...config,
            headers: {
                "Content-Type": "application/json",
            },
            method: "PATCH",
            body: JSON.stringify(data),
        });
    }

    async delete(url, config = {}) {
        return this._request(url, {
            ...config,
            method: "DELETE",
        });
    }

    async _request(
        endpointUri,
        config,
        { shouldRemove = false, ...options } = {},
    ) {
        await ConfigurationManager.refreshConfigurationFile();
        const uri = this._getUri(endpointUri);
        try {
            const globalHeaders = await this._getHeaders();
            config.headers = {
                ...globalHeaders,
                ...config.headers,
            };
            if (shouldRemove) {
                delete config.headers["Content-Type"];
            }
            const response = await fetch(uri, config);
            const finalResponse = await this._handleResponse(response, options);
            return finalResponse;
        } catch (err) {
            throw new Error(
                `error when calling '${uri}' \n- message: "${err}"`,
                { cause: err },
            );
        }
    }
}

export default new Api();
